/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';

import Typo from '../../content/components/typo';

import styles from '../styles/uikitManageManagePageBody.module.scss';

const ManagePageBody = ({
  children,
  contentsHeaderText = i18n.t('properties', 'Properties'),
  hasContentsHeader = false,
  hasNav = false,
  navComponent = null,
  navItemId = '',
  shouldNavItemBeContentsName = false,
}) => {
  const contents = (
    <div className={styles.contents}>
      {hasNav && <div className={styles.nav}>{navComponent}</div>}
      <div
        className={styles.mainContent}
        {...(hasNav && shouldNavItemBeContentsName ? { 'aria-labelledby': navItemId } : {})}
      >
        {children}
      </div>
    </div>
  );

  return (
    <div className={styles.element}>
      {hasContentsHeader ? (
        <section>
          <header className={styles.contentsHeader}>
            <Typo element="h2" variant="d02">
              {contentsHeaderText}
            </Typo>
          </header>
          {contents}
        </section>
      ) : (
        contents
      )}
    </div>
  );
};

ManagePageBody.propTypes = {
  children: PropTypes.node.isRequired,
  contentsHeaderText: PropTypes.string,
  hasContentsHeader: PropTypes.bool,
  hasNav: PropTypes.bool,
  navComponent: PropTypes.node,
  navItemId: PropTypes.string,
  shouldNavItemBeContentsName: PropTypes.bool,
};

export default ManagePageBody;
